module.exports = __webpack_public_path__ + "img/error.a250d135.png";